import { render, staticRenderFns } from "./EditDressColorModal.vue?vue&type=template&id=3082d724&scoped=true"
import script from "./EditDressColorModal.vue?vue&type=script&lang=js"
export * from "./EditDressColorModal.vue?vue&type=script&lang=js"
import style0 from "./EditDressColorModal.vue?vue&type=style&index=0&id=3082d724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082d724",
  null
  
)

export default component.exports